<template>
  <div>
    <WalletHead />
    <div class="wallet-body">
      <div style="width:100%;display: flex;justify-content: center;align-items: center;padding-bottom: 10px;">
         <button class="topShow"  @click="centerDialogVisible = true" style="font-size:14px;font-weight: 700;text-align: center;width: 30%;">Withdraw Loan</button>
      </div>
      <div class="wallet-inf">
        <span class="span" style="font-size:20px;text-align:center;">Account Balance</span>
        <span style="font-weight: 700;font-size:20px;padding-bottom: 10px;padding-left: 5%;">₱  {{ accountBlance }}</span>
      </div>
      <!-- <div class="wallet-button">
        <button class="round-button" style="font-size:20px" type="text" @click="centerDialogVisible = true">Withdrawal</button>
        <button class="round-button" style="font-size:20px" @click="toRepayment">Repayment</button>
      </div> -->

      <div class="wallet-progress">
        <loadDetails />
      </div>
      <div class="">
        <div class="span" style="padding: 0 10px 0 10px;color:red;font-size:14px">All procedures are processed by our AI System to ensure the security of the funds</div>
      </div>
      <div class="wallet-whitebox1"></div>
    </div>
    <MenuTop />

    <el-dialog title="Please contact the administrator for the withdrawal password" :visible.sync="centerDialogVisible" center>
      <el-form ref="form" :model="form">
        <el-form-item label="Withdrawal amount">
          <el-input v-model="form.accountBlance" disabled></el-input>
        </el-form-item>
        <el-form-item label="Withdrawal password">
          <el-input v-model.trim="form.password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">Cancel</el-button>
        <el-button type="primary" :disabled="isButtonDisabled" @click="ConfirmPassword()">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MenuTop from "@/components/MenuTop.vue";
import WalletHead from "../components/WalletHead.vue";
import loadDetails from "@/components/loadDetails.vue";

import axios from "axios";

export default {
  components: {
    WalletHead,
    MenuTop,
    loadDetails
  },
  data() {
    return {
      //提现按钮禁用
      isButtonDisabled: false,
      accountBlance: 0,
      visible: false,
      loanAmount: "",
      centerDialogVisible: false,
      dialogVisible: false,
      form: {
        accountBlance: "",
        password: ""
      }
    };
  },
  methods: {
    ConfirmPassword() {
      this.isButtonDisabled = true; // 禁用按钮
      if (this.accountBlance > 0) {
        this.withdrawFunds();
        setTimeout(() => {
          this.isButtonDisabled = false; // 10秒后重新启用按钮
        }, 10000); // 10000毫秒 = 10秒
      } else {
        this.$message.error(
            "Wallet balance is zero, not allowed to reflect !!!!"
        );
        setTimeout(() => {
          this.isButtonDisabled = false; // 即使在错误情况下，也在10秒后重新启用按钮
        }, 10000);
      }
    },
    toRepayment() {
      this.$router.push("/repayment");
    },

    getWalletBalance() {
      axios
        .get(`/walletSys/wallet/wallet/${+sessionStorage.getItem("token")}`, {
          withCredentials: true
        })
        .then(res => {
          this.accountBlance = res.data.data["balance"] || 0;
          this.form.accountBlance = this.accountBlance;
          this.centerDialogVisible = false;
        })
        .catch(error => {
          // //console.log(error);
        });
    },

    withdrawFunds() {
      //console.log(value);
      axios
        .post(
          `/walletSys/wallet/withdrawal`,
          {
            password: this.form.password,
            uid: sessionStorage.getItem("token")
          },
          {
            withCredentials: true
          }
        )
        .then(res => {
          //console.log(res);
          if (res.data.code == 200) {
            this.accountBlance = 0;
            this.$message({
              type: "success",
              message: "Withdrawal success"
            });
            this.$router.push('/success')
          } else {
            this.$message.error("Wrong password, please try again");
          }
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.getWalletBalance();
  }
};
</script>

<style scoped>

.topShow {
    width: 100%;
    height: 27px;
    line-height: 25px;
    border-radius: 25px;
    background-color: #a95159;
    font-size: 15px;
    color: #fff;
    border: none;
    cursor: pointer;
}

.wallet-body {
  width: 100%;
  position: relative;
  margin-top: 80px;
}
.wallet-inf {
  height: auto;
  background-color: #a95159;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  font-size: 15px;
  text-align: left;
  position: relative;
  padding: 5px 0 5px 10px;
}

.wallet-inf span {
  margin-top: 10px;
}
.wallet-button {
  padding: 0 40px;
  margin-top: 30px;
  height: 50px;
  display: flex;
  justify-content: space-between;
}

.wallet-button .round-button {
  width: 43%;
  height: 50px;
  line-height: 25px;
  border-radius: 25px;
  background-color: #a95159;
  font-size: 15px;
  color: #fff;
  padding: 10px 0 10px 0;
  border: none;
  cursor: pointer;
}

.wallet-inf .horizontal-bar1,
.wallet-inf .horizontal-bar2 {
  position: absolute;
  width: 10px;
  height: 1px;
  background: #fff;
}

.wallet-inf .horizontal-bar1 {
  left: 10px;
  top: 52px;
}

.wallet-inf .horizontal-bar2 {
  left: 10px;
  top: 54px;
}

.wallet-progress {
  width: 100%;
}

.wallet-progress .progress-context {
  width: 50%;
  margin-top: 60px;
  height: 40px;
  background: #e7d9d9;
  color: #555;
  padding-top: 10px;
  display: flex;
  padding-left: 30px;
  position: relative;
}

.progress-context .circle {
  position: absolute;
  background: #e5de91;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  left: 18px;
  top: 18px;
}

.wallet-whitebox {
  height: 120px;
}
.wallet-message {
  padding: 0 25%;
}
.wallet-message .span {
  text-align: center;
  width: 100%;
  color: #555;
}

.wallet-whitebox1 {
  height: 70px;
}
@media screen and (max-width: 800px) {
  ::v-deep .el-dialog {
    width: 100%;
  }
}
</style>
